import { combineReducers } from 'redux'

import apiKeys from './api-keys'

export default combineReducers({
  apiKeys,
})
